import React from 'react';

const SkeletonLoader = ({
  className = '',
  variant = 'rectangular',
  width = '100%',
  height = '1rem',
  animation = 'pulse'
}) => {
  const baseClasses = 'bg-muted animate-pulse';
  const animationClass = animation === 'pulse' ? 'animate-pulse' : 'animate-pulse';

  let variantClasses = '';
  switch (variant) {
    case 'circular':
      variantClasses = 'rounded-full';
      break;
    case 'text':
      variantClasses = 'rounded h-4';
      height = '1rem';
      break;
    case 'rectangular':
    default:
      variantClasses = 'rounded';
      break;
  }

  const style = {
    width: typeof width === 'number' ? `${width}px` : width,
    height: typeof height === 'number' ? `${height}px` : height,
  };

  return (
    <div
      className={`${baseClasses} ${variantClasses} ${animationClass} ${className}`}
      style={style}
    />
  );
};

// Pre-built skeleton components for common use cases
export const SkeletonText = ({ lines = 1, className = '' }) => (
  <div className={`space-y-2 ${className}`}>
    {Array.from({ length: lines }).map((_, i) => (
      <SkeletonLoader
        key={i}
        variant="text"
        width={i === lines - 1 ? '60%' : '100%'}
        height="1rem"
      />
    ))}
  </div>
);

export const SkeletonCard = ({ className = '' }) => (
  <div className={`border rounded-lg p-4 space-y-3 ${className}`}>
    <SkeletonLoader variant="text" width="60%" height="1.25rem" />
    <SkeletonText lines={2} />
    <div className="flex gap-2">
      <SkeletonLoader variant="rectangular" width="80px" height="24px" />
      <SkeletonLoader variant="rectangular" width="80px" height="24px" />
    </div>
  </div>
);

export const SkeletonTable = ({ rows = 5, columns = 3, className = '' }) => (
  <div className={`space-y-3 ${className}`}>
    {/* Header */}
    <div className="flex gap-4">
      {Array.from({ length: columns }).map((_, i) => (
        <SkeletonLoader key={i} variant="text" width="100px" height="1rem" />
      ))}
    </div>
    {/* Rows */}
    {Array.from({ length: rows }).map((_, rowIndex) => (
      <div key={rowIndex} className="flex gap-4">
        {Array.from({ length: columns }).map((_, colIndex) => (
          <SkeletonLoader
            key={colIndex}
            variant="text"
            width={colIndex === 0 ? '120px' : '80px'}
            height="1rem"
          />
        ))}
      </div>
    ))}
  </div>
);

export const SkeletonList = ({ items = 3, className = '' }) => (
  <div className={`space-y-3 ${className}`}>
    {Array.from({ length: items }).map((_, i) => (
      <div key={i} className="flex items-center gap-3">
        <SkeletonLoader variant="circular" width="32px" height="32px" />
        <div className="flex-1">
          <SkeletonLoader variant="text" width="60%" height="1rem" />
          <SkeletonLoader variant="text" width="40%" height="0.75rem" className="mt-1" />
        </div>
      </div>
    ))}
  </div>
);

export default SkeletonLoader;
